import { connect } from 'react-redux';
import { StatusConfigurationComponent } from '../appComponent'
import { bindActionCreators } from 'redux'
import { ticketCommonActions } from '../ticket-management';

const mapStateToProps = (state) => {
  const {
    identity, alert, tenant, CaseValueConfig,
    CaseFieldConfig, CaseSectionConfig,
    CaseSectionFieldConfig,
    CaseMasterListConfig,
    CaseNoteConfig,
    CaseDocumentConfig,
    CaseUserConfig,
    RelatedCaseConfig,
    globalSetting,
    tenantConfig,
    MetricsConfig
    // workspace
  } = state;
  return {
    identity,
    alert,
    tenant,
    CaseValueConfig,
    CaseFieldConfig,
    CaseSectionConfig,
    CaseSectionFieldConfig,
    CaseMasterListConfig,
    CaseNoteConfig,
    CaseDocumentConfig,
    CaseUserConfig,
    RelatedCaseConfig,
    globalSetting,
    tenantConfig,
    MetricsConfig
    // workspace
  };
}

const mapDispatchToProps = (dispatch, props) => ({
  ...bindActionCreators(
    {
      ...ticketCommonActions,
    },
    dispatch
  ),
  moduleName: props.moduleName,
  title: 'Create Status Configuration',
})

export default connect(mapStateToProps, mapDispatchToProps)(StatusConfigurationComponent);


